import * as React from 'react';
import { isMobile } from 'src/utils/responsiveHelpers';
import './FileModal.scss';
import Modal from '../../../common/Modal';
import { downloadFile } from 'src/utils/downloadHelper';
import env from 'src/shared/env';

interface IFileModalProps {
  onUploadFile: (file: FormData) => void;
  onCloseModal: () => void;
  t?: any;
}

interface IFileModalState {
  isMobile: boolean;
}

class FileModal extends React.Component<IFileModalProps, IFileModalState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile()
    };
  }

  private loadFileClick = () => {
    document.getElementById('upload').click();
  };

  private onUploadFile = (e: any) => {
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    this.props.onUploadFile(formData);
    this.props.onCloseModal();
  };

  private onDownloadFile = (e: any) => {
    downloadFile(
      [
        'MFC,NAME,Quantity,ShipmentMarking',
        'RPI,CH5829,3,mark1',
        'RPI,MC450,4,mark2',
        'WPL,WPW10245259,4,mark3'
      ].join('\n'),
      'example.xlsx',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );
  };

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  private renderForm = () => {
    const { t } = this.props;
    return (
      <div className="rp-cart-file-modal">
        <span
          onClick={e => this.props.onCloseModal()}
          className="rpds-close rp-cart-file-modal--close-icon"
        />
        <div className="rp-cart-file-modal--instruction-title">
          {t('fileUpload.chooseFileHeaderTxt')}:
        </div>
        <button
          className="rp-cart-file-modal--upload-button"
          onClick={e => this.loadFileClick()}
        >
          <span className="rpds-add" />
        </button>
        <input
          id="upload"
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onChange={event => {
            this.onUploadFile(event);
          }}
        />
        <div className="rp-cart-file-modal--title">
          {t('fileUpload.uploadOrderFromFile')}
        </div>
        <p className="rp-cart-file-modal--paragraph-type">
          {t('fileUpload.uploadlocationHelperTxt')}
        </p>
        <p className="rp-cart-file-modal--paragraph-instruction">
          {t('fileUpload.uploadSupportTxt')}:
        </p>
        <a
          href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/example.xlsx`}
          className="secondary-button rp-cart-file-modal--download-button"
        >
          {t('fileUpload.downloadExampleFile')}
        </a>
      </div>
    );
  };

  public render() {
    const { t } = this.props;
    return this.state.isMobile ? (
      <div className="rp-cart-file-modal--mobile">
        <div
          onClick={e => this.props.onCloseModal()}
          className="rp-cart-file-modal--mobile-cancel"
        >
          <span className="rpds-close cancel-icon" />
          {t('common.cancel')}
        </div>
        {this.renderForm()}
      </div>
    ) : (
      <Modal handleCloseModal={this.props.onCloseModal}>
        {this.renderForm()}
      </Modal>
    );
  }
}

export default FileModal;
